import React from "react";
import { t } from "ttag";

import { WagtailForm } from "@reactivated";

import { Checkbox, CheckboxGroup } from "./Checkbox";
import { Radio, RadioGroup } from "./Radio";
import { SelectField, SelectOption } from "./SelectField";
import { TextField } from "./TextField";

import styles from "./inputs.module.scss";

export {
    SelectField,
    SelectOption,
    TextField,
    Checkbox,
    CheckboxGroup,
    Radio,
    RadioGroup,
};

function cleanValue(x: unknown) {
    if (typeof x === "string") return x;
    else return undefined;
}

export default function Widget({
    widget,
    name,
    help_text,
    label,
}: WagtailForm["fields"][string]) {
    if (widget.is_hidden) {
        return (
            <input
                type="hidden"
                name={widget.name}
                value={cleanValue(widget.value)}
            />
        );
    }

    if (!widget.required) {
        label = label + t` (Optional)`;
    }

    const attrs = {
        ...widget.attrs,
        className:
            help_text && help_text.length > 100 ? styles.fullWidth : undefined,
    };

    switch (widget.tag) {
        case "django.forms.widgets.TextInput":
        case "django.forms.widgets.EmailInput":
        case "django.forms.widgets.Textarea":
            return (
                <TextField
                    {...attrs}
                    defaultValue={cleanValue(widget.value)}
                    isRequired={widget.required}
                    name={name}
                    description={cleanValue(help_text)}
                    label={label}
                    type={"type" in widget ? widget.type : undefined}
                    multiline={widget.tag === "django.forms.widgets.Textarea"}
                />
            );
        case "django.forms.widgets.Select":
            return (
                <SelectField
                    {...attrs}
                    label={label}
                    description={cleanValue(help_text)}
                    name={name}
                    isRequired={widget.required}
                    defaultSelectedKey={cleanValue(widget.value)}
                >
                    {widget.optgroups.flatMap((group) =>
                        group[1].map((opt) => {
                            const value = cleanValue(opt.value);
                            return (
                                <SelectOption
                                    key={value}
                                    id={value}
                                    value={opt}
                                >
                                    {opt.label}
                                </SelectOption>
                            );
                        }),
                    )}
                </SelectField>
            );
        case "django.forms.widgets.CheckboxInput":
            return (
                <CheckboxGroup
                    {...attrs}
                    isRequired={widget.required}
                    description={cleanValue(help_text)}
                >
                    <Checkbox name={name}>{label}</Checkbox>
                </CheckboxGroup>
            );
        default:
            console.warn(`Unknown widget type: ${widget.tag}`);
            return (
                <input
                    type="hidden"
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
                    value={cleanValue((widget as any).value)}
                    name={name}
                />
            );
    }
}
